import Checkbox from "./checkbox";

export { Checkbox };
export default Checkbox;
